import { render } from "./MySales.vue?vue&type=template&id=4e73442a"
import script from "./MySales.vue?vue&type=script&lang=js"
export * from "./MySales.vue?vue&type=script&lang=js"
script.render = render

export default script